import OrcamentoItem from "./OrcamentoItem";

export default class Orcamento {
  constructor() {
    this.id = 0;
    this.cliente = "New Energy Tech";
    this.data = new Date();
    this.titulo = "Descreva o título do orçamento.";
    this.local = "Mossoró";
    this.observacao =
      "1 - Cotação: Venda (M.Obra+M.Prima) Impostos inclusos, ICMS isento, PIS, Cofins e IPI optante do simples a incluir conforme legislação e classificação do produto." +
      "\n" +
      "2 - Frete: ( x ) Incluso ou (  ) Não Incluso" +
      "\n" +
      "3 - Acabamento Superfícial: ( X ) Incluso ou ( ) Não Incluso" +
      "\n" +
      "4 - Favor enviar os desenhos eletrônicos em extensão DXF ou DWG e escala 1:1" +
      "\n" +
      "5 - Caso não esteja detalhado nos desenhos ou em seu pedido, enviar via e-mail as informações complementares do produto. Ex.(Normas técnicas, embalagens, local de entrega, legislação, etc.)." +
      "\n" +
      "6 - Tolerância geral p/ corte: (+ -) 0,1 a 0,2 mm." +
      "\n" +
      "7 - Todos os equipamentos serão entregues em Mossoró." +
      "\n" +
      "8 - A validade da proposta é de 10 dias." +
      "\n" +
      "9 - Prazo para a entrega de 30 dias." +
      "\n" +
      "10 - NCN 73089090 " +
      "\n" +
      "11 - O percentual de mão de obra nesta atividade é isento de acordo com a IN 69/2002 de 15/05" +
      "\n" +
      "12 - A condição de pagamento é 50% do valor no aceite e os outros 50% a faturar.";
    this.total = 0.0;
    this.status = "Novo";
    this.desconto = 0.0;
    this.responsavel = "Nome do responsável por receber";
    this.itens = [];
  }

  update(orc) {
    this.id = orc.id;
    this.cliente = orc.cliente;
    this.data = orc.data;
    this.titulo = orc.titulo;
    this.local = orc.local;
    this.observacao = orc.observacao;
    this.total = this.getTotalCurrency(orc.total);
    this.status = orc.status;
    this.desconto = orc.desconto;
    this.responsavel = orc.responsavel;
    this.itens = [];
    orc.itens.forEach((item) => {
      this.itens.push(
        new OrcamentoItem(
          item.id,
          item.codigo,
          item.descricao,
          item.quantidade,
          item.unidade,
          item.valor,
          item.total
        )
      );
    });
  }

  calcularTotal() {
    var calculo = 0.0;
    this.itens.forEach((item) => {
      item.calcularTotal();
      calculo = calculo + item.getTotalNumber();
    });

    //Aplica o desconto se houver
    if (this.desconto != 0) {
      var descontar = (calculo * this.desconto) / 100.0;
      calculo = calculo - descontar;
    }

    this.total = this.getTotalCurrency(calculo);
  }

  getTotalCurrency(valor) {
    valor = parseFloat(valor).toFixed(2);
    var inteira = valor.substr(0, valor.length - 3);
    var ajuste = inteira.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var decimal = valor.substr(valor.length - 3, valor.length);
    decimal = decimal.replace(".", ",");
    return "R$ " + ajuste + decimal;
  }

  setTotalNumber() {
    this.total = Number(this.total.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
  }
}
